export default __webpack_public_path__ + "static/media/home.a6337a63.png";